import map from './components/map';

window.initiateMap = map.initMap;
